"use client";
import { getCurrentDate } from "@sa-nu/shared-utils/date";

import type {
  AccommodationReservationProvider,
  OccupancyLimitTargetType,
} from "../../../../__generated__/gql/graphql";
import { getDefaultReservationLeadMonths } from "../../../../constants";
import { ReservationCalendar } from "../../../_components/reservation-form/reservation-calendar";

export default function AvailabilityCalendar({
  providerOrLimit,
}: {
  providerOrLimit: OccupancyLimitTargetType | AccommodationReservationProvider;
}) {
  return (
    <ReservationCalendar
      providerOrLimit={providerOrLimit}
      selected={null}
      originalReservationData={null}
      setSelected={() => {}}
      minNight={getCurrentDate()}
      maxNight={getCurrentDate().add({
        months: getDefaultReservationLeadMonths(),
      })}
      isSampleMode={true}
    />
  );
}
